import cn from "classnames";
import styles from "./AccordionGroup.module.scss";
import { AccordionItem, AccordionItemProps } from "./AccordionItem";
import { AccordionItemWithEditorContent } from "./AccordionItemWithEditorContent";
import { StrapiFaqItemComponentData } from "@/types/strapi/components/shared/faqItem";

type AccordionGroupProps = {
  className?: string;
  items: (AccordionItemProps | StrapiFaqItemComponentData)[];
};

export const AccordionGroup = ({ className, items }: AccordionGroupProps) => {
  return (
    <div className={cn(styles.wrapper, className)}>
      {items.map((props, index) =>
        "question" in props ? (
          <AccordionItemWithEditorContent
            key={index}
            className={styles.item}
            heading={props.question}
            content={props.answer}
          />
        ) : (
          <AccordionItem key={index} className={styles.item} {...props} />
        )
      )}
    </div>
  );
};
